import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ConditionType} from 'common/widgets/cohorts-query-builder/models/enums/builder-enums';

import {ClauseComponent} from '../index';
import template from './index.jade';
import css from './index.styl?inline';

class CohortsPeopleClause extends ClauseComponent {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'user-id': {type: `number`, description: `ID of user viewing the builder`},
    };
  }

  shouldUpdate(state) {
    return super.shouldUpdate(state) && !!state.stagedCohort.literals[this.literalIdx].properties;
  }

  get config() {
    return {
      ...super.config,
      useShadowDom: true,
      css,
      template,
      helpers: {
        ...super.config.helpers,
        getActionLabel: () => `${this.app.getActiveDataGroupLabel()} that`,
        getActionOperatorLabel: () => (this.helpers.isNegated() ? `do not have` : `have`),
        getResourceLabel: () =>
          this.helpers
            .getPropertyFilterLabelParts(0)
            .map((part) => part.label)
            .join(` `),
      },
    };
  }

  get conditionType() {
    return ConditionType.People;
  }
}

export const CohortsPeopleClauseEl = defineAndMakeJsxFactory(`cohorts-people-clause`, CohortsPeopleClause);
